<ngb-carousel class="edu-carousel" #carouselComponent [showNavigationIndicators]="false" interval="5000000" *ngIf="testimonials">
	<ng-template ngbSlide *ngFor="let testimonial of testimonials">
		<div class="md:w-full flex justify-center py-7 pb-10">
			<edu-testimonial-card [content]="testimonial.content" [name]="testimonial.name" [description]="testimonial.description"></edu-testimonial-card>
		</div>
	</ng-template>
</ngb-carousel>
